import { render, staticRenderFns } from "./TrainingItemURL.vue?vue&type=template&id=fecc9658&scoped=true&"
import script from "./TrainingItemURL.vue?vue&type=script&lang=js&"
export * from "./TrainingItemURL.vue?vue&type=script&lang=js&"
import style0 from "./TrainingItemURL.vue?vue&type=style&index=0&id=fecc9658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecc9658",
  null
  
)

export default component.exports